import React, { createContext, useState } from "react";

interface DetailsActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: any;
  setElement: (element: any) => void;
  selectedLang: string;
  setSelectedLang: (selectedLang: string) => void;
  attributes: any[],
  setAttributes: (attributes: any) => void;
  commercePrice: number
  setCommercePrice: (price: number) => void
  adjustmentError: any;
  setAdjustmentError: (error: any) => void;
}

export const DetailsActionContext = createContext<DetailsActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},  
  element: null,
  setElement: () => {},
  selectedLang: "",
  setSelectedLang: () => {},
  attributes: [],
  setAttributes: () => {},
  commercePrice: 0,
  setCommercePrice: () => {},
  adjustmentError: null,
  setAdjustmentError: () => {},
});

interface DetailsActionProviderProps {
  children: React.ReactNode;
}

export const DetailsActionProvider: React.FC<DetailsActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(null);
  const [selectedLang, setSelectedLang] = useState<string>("");
  const [attributes, setAttributes] = useState<any[]>([]);
  const [commercePrice, setCommercePrice] = useState<number>(0);
  const [adjustmentError, setAdjustmentError] = useState<any>(null);

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
    selectedLang,
    setSelectedLang,
    attributes,
    setAttributes,
    commercePrice,
    setCommercePrice,
    adjustmentError,
    setAdjustmentError
  };
  return (
    <DetailsActionContext.Provider value={value}>      
      {children}
    </DetailsActionContext.Provider>
  );
};
